// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 获取国家列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetCountryListResp
export const getCountryList = (data) => {
  return service({
    url: '/v1/basic/getCountryList',
    method: 'post',
    data
  })
}
// 获取应用流通货币列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetAppCoinListResp
export const getAppCoinList = (data) => {
  return service({
    url: '/v1/basic/getAppCoinList',
    method: 'post',
    data
  })
}
// 获取菜单列表
// Req : open_proto.client.v1.basic.ResMenuListReq
// Resp: open_proto.client.v1.basic.ResMenuListResp
export const resMenuList = (data) => {
  return service({
    url: '/v1/basic/menuList',
    method: 'post',
    data
  })
}
// 获取首页模板
// Req : open_proto.client.v1.basic.GetHomepageReq
// Resp: open_proto.client.v1.basic.GetHomepageResp
export const getHomepage = (data) => {
  return service({
    url: '/v1/basic/getHomepage',
    method: 'post',
    data
  })
}
// 浮窗模板
// Req : open_proto.client.v1.basic.GetFloatingReq
// Resp: open_proto.client.v1.basic.GetFloatingResp
export const getFloating = (data) => {
  return service({
    url: '/v1/basic/getFloating',
    method: 'post',
    data
  })
}
// 浮窗点击
// Req : open_proto.client.v1.basic.FloatingClickReq
// Resp: open_proto.client.v1.basic.FloatingClickResp
export const floatingClick = (data) => {
  return service({
    url: '/v1/basic/floatingClick',
    method: 'post',
    data
  })
}
// 获取跑马灯模板
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetNoticeTemplateResp
export const getMarqueeTemplate = (data) => {
  return service({
    url: '/v1/basic/getMarqueeTemplate',
    method: 'post',
    data
  })
}
// 获取公告模板
// Req : open_proto.client.v1.basic.GetNoticeTemplateReq
// Resp: open_proto.client.v1.basic.GetNoticeTemplateResp
export const getNoticeTemplate = (data) => {
  return service({
    url: '/v1/basic/getNoticeTemplate',
    method: 'post',
    data
  })
}
// 获取公告模板V2
// Req : open_proto.client.v1.basic.GetNoticeTemplateV2Req
// Resp: open_proto.client.v1.basic.GetNoticeTemplateV2Resp
export const getNoticeTemplateV2 = (data) => {
  return service({
    url: '/v1/basic/getNoticeTemplateV2',
    method: 'post',
    data
  })
}
// 获取品牌模板
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetBrandTemplateResp
export const getBrandTemplate = (data) => {
  return service({
    url: '/v1/basic/getBrandTemplate',
    method: 'post',
    data
  })
}
// 获取客服模板
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetCustomerTemplateResp
export const getCustomerTemplate = (data) => {
  return service({
    url: '/v1/basic/getCustomerTemplate',
    method: 'post',
    data
  })
}
// 获取轮播图模板
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetCarouselTemplateResp
export const getCarouselTemplate = (data) => {
  return service({
    url: '/v1/basic/getCarouselTemplate',
    method: 'post',
    data
  })
}
// 获取会员特权模板
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetMemberPrivilegeTemplateResp
export const getMemberPrivilegeTemplate = (data) => {
  return service({
    url: '/v1/basic/getMemberPrivilegeTemplate',
    method: 'post',
    data
  })
}
// 获取跳转游戏列表
// Req : open_proto.client.v1.basic.GetGameListByJumpListReq
// Resp: open_proto.client.v1.basic.GetGameListByJumpListResp
export const getGameListByJumpList = (data) => {
  return service({
    url: '/v1/basic/getGameListByJumpList',
    method: 'post',
    data
  })
}
// 获取跳转游戏的厂商组列表
// Req : open_proto.client.v1.basic.GetJumpGameBrandGroupListReq
// Resp: open_proto.client.v1.basic.GetJumpGameBrandGroupListResp
export const getJumpGameBrandGroupList = (data) => {
  return service({
    url: '/v1/basic/getJumpGameBrandGroupList',
    method: 'post',
    data
  })
}
// 获取h5顶部模板
// Req : open_proto.client.v1.basic.GetH5TopTemplateReq
// Resp: open_proto.client.v1.basic.GetH5TopTemplateResp
export const getH5TopTemplate = (data) => {
  return service({
    url: '/v1/basic/getH5TopTemplate',
    method: 'post',
    data
  })
}
// 获取文案模板
// Req : open_proto.client.v1.basic.GetDocumentTemplateReq
// Resp: open_proto.client.v1.basic.GetDocumentTemplateResp
export const getDocumentTemplate = (data) => {
  return service({
    url: '/v1/basic/getDocumentTemplate',
    method: 'post',
    data
  })
}
// 获取银行列表
// Req : open_proto.client.v1.basic.GetBankListReq
// Resp: open_proto.client.v1.basic.GetBankListResp
export const getBankList = (data) => {
  return service({
    url: '/v1/basic/getBankList',
    method: 'post',
    data
  })
}
// 获取底部模板
// Req : open_proto.client.v1.basic.GetBottomTemplateReq
// Resp: open_proto.client.v1.basic.GetBottomTemplateResp
export const getBottomTemplate = (data) => {
  return service({
    url: '/v1/basic/getBottomTemplate',
    method: 'post',
    data
  })
}
// 获取底部导航模板
// Req : open_proto.client.v1.basic.GetBottomNavigationTemplateReq
// Resp: open_proto.client.v1.basic.GetBottomNavigationTemplateResp
export const getBottomNavigationTemplate = (data) => {
  return service({
    url: '/v1/basic/getBottomNavigationTemplate',
    method: 'post',
    data
  })
}
// 获取Vip等级描述
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.VipLevelDescResp
export const getVipLevelDesc = (data) => {
  return service({
    url: '/v1/basic/getVipLevelDesc',
    method: 'post',
    data
  })
}
// 获取落地页信息
// Req : open_proto.client.v1.basic.GetLandingPageInfoReq
// Resp: open_proto.client.v1.basic.GetLandingPageInfoResp
export const getLandingPageInfo = (data) => {
  return service({
    url: '/v1/basic/getLandingPageInfo',
    method: 'post',
    data
  })
}
// 获取PWA落地页信息
// Req : open_proto.client.v1.basic.GetLandingPwaPageInfoReq
// Resp: open_proto.client.v1.basic.GetLandingPwaPageInfoResp
export const getLandingPwaPageInfo = (data) => {
  return service({
    url: '/v1/basic/getLandingPwaPageInfo',
    method: 'post',
    data
  })
}
// 获取马甲包信息
// Req : open_proto.client.v1.basic.HorseClipBagReq
// Resp: open_proto.client.v1.basic.HorseClipBagInfo
export const getHorseClipBagInfo = (data) => {
  return service({
    url: '/v1/basic/getHorseClipBagInfo',
    method: 'post',
    data
  })
}
// 获取汇率
// Req : open_proto.client.v1.basic.CoinExchangeRateReq
// Resp: open_proto.client.v1.basic.CoinExchangeRateResp
export const getCoinExchangeRate = (data) => {
  return service({
    url: '/v1/basic/getCoinExchangeRate',
    method: 'post',
    data
  })
}
// 获取分享信息
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.ShareInfoResp
export const getShareInfo = (data) => {
  return service({
    url: '/v1/basic/getShareInfo',
    method: 'post',
    data
  })
}
// 分享模板
// Req : open_proto.client.v1.basic.GetShareTemplateReq
// Resp: open_proto.common.TemplateShareLanguage
export const getShareTemplate = (data) => {
  return service({
    url: '/v1/basic/getShareTemplate',
    method: 'post',
    data
  })
}
// 获取元体育赛事列表
// Req : open_proto.client.v1.basic.MetaMatchSaleListReq
// Resp: open_proto.client.v1.basic.MetaMatchSaleListResp
export const getMetaMatchSaleList = (data) => {
  return service({
    url: '/v1/basic/getMetaMatchSaleList',
    method: 'post',
    data
  })
}
// 预测赛事
// Req : open_proto.client.v1.basic.PredictedEventsReq
// Resp: open_proto.client.v1.basic.PredictedEventsResp
export const predictedEvents = (data) => {
  return service({
    url: '/v1/basic/predictedEvents',
    method: 'post',
    data
  })
}
// 获取渠道信息
// Req : open_proto.client.v1.basic.GetChannelInfoReq
// Resp: open_proto.client.v1.basic.GetChannelInfoResp
export const getChannelInfo = (data) => {
  return service({
    url: '/v1/basic/getChannelInfo',
    method: 'post',
    data
  })
}
// 上传图片
// Req : open_proto.client.v1.basic.UploadImageReq
// Resp: open_proto.client.v1.basic.UploadImageResp
export const uploadImage = (data) => {
  return service({
    url: '/v1/basic/uploadImage',
    method: 'post',
    data
  })
}
// 刷新页面
// Req : open_proto.client.v1.basic.RefreshPageReq
// Resp: open_proto.client.v1.basic.RefreshPageResp
export const refreshPage = (data) => {
  return service({
    url: '/v1/basic/refreshPage',
    method: 'post',
    data
  })
}
// 获取启用的功能
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetEnableFeatureResp
export const getEnableFeature = (data) => {
  return service({
    url: '/v1/basic/getEnableFeature',
    method: 'post',
    data
  })
}
// 上传图片
// Req : open_proto.client.v1.basic.UploadImageReq
// Resp: open_proto.client.v1.basic.UploadImageResp
export const uploadImage2 = (data) => {
  return service({
    url: '/v1/basic/uploadImage2',
    method: 'post',
    data
  })
}
// 通过id获取包机器人配置
// Req : open_proto.client.v1.basic.GetPacketRobotBySidReq
// Resp: open_proto.client.v1.basic.GetPacketRobotBySidResp
export const getPacketRobotBySid = (data) => {
  return service({
    url: '/v1/basic/getPacketRobotBySid',
    method: 'post',
    data
  })
}
// 通过file路径获取base64数据
// Req : open_proto.client.v1.basic.GetBase64ByFileUrlReq
// Resp: open_proto.client.v1.basic.GetBase64ByFileUrlResp
export const getBase64ByFileUrl = (data) => {
  return service({
    url: '/v1/basic/getBase64ByFileUrl',
    method: 'post',
    data
  })
}
// 清空游戏版本缓存
// Req : open_proto.client.v1.basic.ClearGameVersionCacheReq
// Resp: open_proto.client.v1.basic.ClearGameVersionCacheResp
export const clearGameVersionCache = (data) => {
  return service({
    url: '/v1/basic/clearGameVersionCache',
    method: 'post',
    data
  })
}
// 获取新用户充值详情
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetNewUserRechargeDetailResp
export const getNewUserRechargeDetail = (data) => {
  return service({
    url: '/v1/basic/getNewUserRechargeDetail',
    method: 'post',
    data
  })
}
// 获取滚动跑马灯信息
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.basic.GetScrollMarqueeResp
export const getScrollMarquee = (data) => {
  return service({
    url: '/v1/basic/getScrollMarquee',
    method: 'post',
    data
  })
}
// 获取二级页面信息
// Req : open_proto.client.v1.basic.GetTemplateErJiPageReq
// Resp: open_proto.client.v1.basic.GetTemplateErJiPageResp
export const getTemplateErJiPage = (data) => {
  return service({
    url: '/v1/basic/getTemplateErJiPage',
    method: 'post',
    data
  })
}
// 用户访问
// Req : open_proto.client.v1.basic.UserVisitReq
// Resp: open_proto.common.SuccessResp
export const userVisit = (data) => {
  return service({
    url: '/v1/basic/userVisit',
    method: 'post',
    data
  })
}
// 获取H5个人中心模版
// Req : open_proto.client.v1.basic.GetPersonalCenterTemplateReq
// Resp: open_proto.client.v1.basic.GetPersonalCenterTemplateResp
export const getPersonalCenterTemplate = (data) => {
  return service({
    url: '/v1/basic/getPersonalCenterTemplate',
    method: 'post',
    data
  })
}
// 获取视频列表
// Req : open_proto.client.v1.basic.GetVideoListReq
// Resp: open_proto.client.v1.basic.GetVideoListResp
export const getVideoList = (data) => {
  return service({
    url: '/v1/basic/getVideoList',
    method: 'post',
    data
  })
}
// 通过uuid获取视频信息
// Req : open_proto.client.v1.basic.GetVideoByUuidReq
// Resp: open_proto.client.v1.basic.VideoInfo
export const getVideoByUuid = (data) => {
  return service({
    url: '/v1/basic/getVideoByUuid',
    method: 'post',
    data
  })
}
// 获取用户视频观看次数
// Req : open_proto.client.v1.basic.GetVideoViewsReq
// Resp: open_proto.client.v1.basic.GetVideoViewsResp
export const getVideoViews = (data) => {
  return service({
    url: '/v1/basic/getVideoViews',
    method: 'post',
    data
  })
}
